import {z} from 'zod';

export const tireOrderAuthorizationProfileSchema = z.object({
  authorizationProfileId: z.string(),
});

export type TireOrderAuthorizationProfileFormValues = z.infer<
  typeof tireOrderAuthorizationProfileSchema
>;
